import { css } from 'styled-components'
import { MOBILE_LAYOUT_QUERY } from 'utils/mobileLayout'

// Small focused form controls trigger automatic page zoom in iOS Safari.
export const mobileInputTextStyles = css`
  @media ${MOBILE_LAYOUT_QUERY} {
    && {
      font-size: 1rem;
    }
  }
`
